import { styled } from '@material-ui/core';
import { flexAlignCenterJustifyCenter } from 'UI/utils/styles';

export const ProgressContainer = styled('div')({
  ...flexAlignCenterJustifyCenter,
  width: '100%',
  height: '100%'
});
